import {B2Discount} from "./data/client.gen";
import {notBlank} from "./utils";

export function isDiscountValid(discount: B2Discount|undefined) {
	return notBlank(discount?.code) && discount?.type === 'Code' && !!discount?.value;
}

export function formatDiscount(language: string, {type, value}: B2Discount) {
	const format = new Intl.NumberFormat(language, {
		minimumFractionDigits: 2,
		maximumFractionDigits: 2,
		style: 'percent',
	});
	return !value || type !== 'Code' ? '' : format.format(value / 100);
}

export function getDiscountReduction(discount: B2Discount|undefined, price: number) {
	return price * (discount?.value ?? 0) / 100;
}

export function applyDiscountReduction(discount: B2Discount|undefined, price: number) {
	return discount?.type !== 'Code' ? price : price - getDiscountReduction(discount, price);
}
